

















import { Component, Vue } from "vue-property-decorator";
import widgets from "shared/widgets";
import Welcome from "../widgets/Welcome.vue";

@Component({
  components: {
    ...widgets,
    Welcome
  }
})
export default class Home extends Vue {}
